'use client'

import {useTranslation} from '../../../hooks/useTranslation'

/** The Omnibus line every shown price reduction carries; `price` is the formatted lowest 30-day price. */
export function LowestPrice30dNote({price, className}: {price: string; className?: string}) {
    const {t} = useTranslation()
    return <p className={className}>{t('client.price.lowest30d', {price})}</p>
}

/** Disclosure for a price chosen automatically from the customer's purchase history. */
export function AutomaticallyPersonalizedNote({className}: {className?: string}) {
    const {t} = useTranslation()
    return <p className={className}>{t('client.price.automaticallyPersonalized')}</p>
}
